import _Abstract from "system/abstract"

export default class Component_ClickBehaviour extends _Abstract {

  constructor(el, options)
  {
    super(el, $.extend(true, {
      type:false,
      target_selector:false,
    }, options), 'component')
    this.bindEvents()
  }
  

    bindEvents()
    {

    
      this.$el.click((e) => this.clickBehaviourElementClicked(e));
    }


    clickBehaviourElementClicked(e)
    {
     

       if(typeof this.options.desktop_only !== "undefined" && this.options.desktop_only)
      {
        var $desktopBreakpointElement = $("#bp-desktop");
        if($desktopBreakpointElement.length)
        {
          var desktopBreakpointSize = $desktopBreakpointElement.width();
          if($(window).outerWidth() < desktopBreakpointSize)
          {
            //If its desktop only, and we're below desktop size, then dont do it
            
            return;
          }
        }
      }



      switch(this.options.type)
      {
        case "set-mobile-sub-page":
        {
          this.setMobileSubPageContent(e);
          break;
        }
        case "close-mobile-sub-page":
        {
          this.closeMobileSubPageContent(e);
          break;
        }
        case "focus":
        {
          this.onFocusOnElement();
          break;
        }

        case "hide-element-and-empty-child-input":
        {
          this.hideElementAndEmptyChildInput();
          break;
        }

        case "hide-element-show-element":
        {
          this.hideElementShowElement(e);
          break;
        }

        case "toggle-class":
        {
          this.toggleClass(e);
          break;
        }

        case "show-element":
        {
          this.showElement();
          break;
        }

        default:
        {
          console.log("No click behaviour case for : " + this.options.type);
          return false;
        }
      }


      if(typeof this.options.scroll_to_new_clicked_element_position !== "undefined" && this.options.scroll_to_new_clicked_element_position)
      {
        // $(window).scrollTop($(e.currentTarget).offset().top);
      }


      $("body").trigger("responsive-image-check",{});


    }

    onFocusOnElement()
    {
      var $target = $(this.options.target_selector);
      if(!$target.length)
      {
        console.log("Target Selector element not found with '"+this.options.target_selector+"' selector");
        return false;
      }
      window.setTimeout(function(){
        $target.focus();
      },20);
    }

    showElement()
    {
      var $target = $(this.options.target_selector);
      if(!$target.length)
      {
        console.log("Target Selector element not found with '"+this.options.target_selector+"' selector");
        return false;
      }

      $target.show();
    }

    hideElementAndEmptyChildInput()
    {
      var $target = $(this.options.target_selector);
      if(!$target.length)
      {
        console.log("Target Selector element not found with '"+this.options.target_selector+"' selector");
        return false;
      }

      $($target).hide();
      $("input",$target).val("");
    }

    toggleClass(_mouseEvent)
    {
      _mouseEvent.preventDefault();

      if(typeof this.options.element_target === "undefined")
      {
        console.log('toggle-class requires element_target to be set in the options');
        return;
      }

      if(typeof this.options.class_name === "undefined")
      {
        console.log('toggle-class requires class_name to be set in the options');
        return;
      }

      var $elementTarget = null;
      if(typeof this.options.closest_element !== "undefined" && this.options.closest_element)
      {
        $elementTarget = $(_mouseEvent.currentTarget).closest(this.options.element_target);
      }
      else
      {
        $elementTarget = $(this.options.element_target);
      }

      if(!$elementTarget.length)
      {
          console.log("No show target element found with '" +this.options.element_target + "' selector" );
          return;
      }

      var className = this.options.class_name;

      if($elementTarget.hasClass(className))
      {
        $elementTarget.removeClass(className)
      }
      else
      {
        $elementTarget.addClass(className)
      }
    }

    hideElementShowElement(_mouseEvent)
    {
      _mouseEvent.preventDefault();

      if(typeof this.options.hide_target === "undefined" || typeof this.options.show_target === "undefined")
      {
        console.log('hide-element-show-element requires hide_target and show_target to be set in the options');
        return;
      }

      var $hidetarget = $(this.options.hide_target);
      var $showTarget = $(this.options.show_target);

      if(!$hidetarget.length)
      {
          console.log("No hide target element found with '" +this.options.hide_target + "' selector" );
          return;
      }
      
      if(!$showTarget.length)
      {
          console.log("No show target element found with '" +this.options.show_target + "' selector" );
          return;
      }

      $hidetarget.addClass("-hide");
      $showTarget.removeClass("-hide");
    }


    setMobileSubPageContent(_mouseEvent)
    {
        var $desktopBreakpointElement = $("#bp-desktop");
        if($desktopBreakpointElement.length)
        {
          var desktopBreakpointSize = $desktopBreakpointElement.width();
          if($(window).outerWidth() >= desktopBreakpointSize)
          {
            //If its desktop only, and we're below desktop size, then dont do it
            return;
          }
        }




      _mouseEvent.preventDefault();

      if(typeof this.options.element_target === "undefined")
      {
        console.log('toggle-class requires element_target to be set in the options');
        return;
      }

      var $elementTarget = null;
      if(typeof this.options.closest_element !== "undefined" && this.options.closest_element)
      {
        $elementTarget = $(_mouseEvent.currentTarget).closest(this.options.element_target);
      }
      else
      {
        $elementTarget = $(".c-main-content").find(this.options.element_target);
      }

      if(!$elementTarget.length)
      {
          console.log("No show target element found with '" +this.options.element_target + "' selector" );
          return;
      }



      var currentWindowScroll = $(window).scrollTop();
      $(window).scrollTop(0);

      $(".c-mobile-sub-page .content").empty();
      //Save the scroll position, so when we close the 'popup' it goes back to the original position
      $(".c-mobile-sub-page__header-back-btn").attr('data-original-scroll-top',currentWindowScroll);
      $("body").addClass("-mobile-sub-page-active");


      var deepCopyClone = true;

      $(".c-mobile-sub-page .content").html($elementTarget.clone(deepCopyClone, deepCopyClone));
    }

    closeMobileSubPageContent(_mouseEvent)
    {
      var $desktopBreakpointElement = $("#bp-desktop");
      if($desktopBreakpointElement.length)
      {
        var desktopBreakpointSize = $desktopBreakpointElement.width();
        if($(window).outerWidth() >= desktopBreakpointSize)
        {
          _mouseEvent.preventDefault();
          //If its desktop only, and we're below desktop size, then dont do it
          return;
        }
      }
      var oldWidowScrollPosition = $(".c-mobile-sub-page__header-back-btn").attr('data-original-scroll-top');
      $("body").removeClass("-mobile-sub-page-active");
      $(window).scrollTop(oldWidowScrollPosition);
    }


}



/** WEBPACK FOOTER **
 ** ./components/click-behaviour.js
 **/